import PropTypes from 'prop-types';
import React from 'react';

import { configs } from '@hero/configs';
import { GIFT_MESSAGE_TYPE } from '@hero/constants';

import { CardMessage } from '../CardMessage';
import { Inputs } from '../Inputs';

import * as S from './style';

function GiftMessage({
  activeGiftMessage,
  logoUrl,
  giftWrapperUrl,
  message,
  senderName,
  selectedGreetingCard,
  isLogoPreview
}) {
  const Component = () => {
    if (
      activeGiftMessage === GIFT_MESSAGE_TYPE.inputMessage ||
      !configs?.experience?.greetingCardEnabled
    ) {
      return (
        <Inputs
          logoUrl={logoUrl}
          giftWrapperUrl={giftWrapperUrl}
          message={message}
          senderName={senderName}
        />
      );
    }
    if (activeGiftMessage === GIFT_MESSAGE_TYPE.cardMessage) {
      return (
        <CardMessage
          logoUrl={logoUrl}
          giftWrapperUrl={giftWrapperUrl}
          greetingCard={selectedGreetingCard}
          isLogoPreview={isLogoPreview}
        />
      );
    }
    return (
      <S.GreetingCardEmptyWrapper giftWrapperUrl={giftWrapperUrl}>
        <S.ExperienceBow />
      </S.GreetingCardEmptyWrapper>
    );
  };

  return Component();
}

GiftMessage.propTypes = {
  activeGiftMessage: PropTypes.string,
  logoUrl: PropTypes.string,
  giftWrapperUrl: PropTypes.string,
  message: PropTypes.string,
  senderName: PropTypes.string,
  selectedGreetingCard: PropTypes.object
};

export { GiftMessage };
